import api from '@/api';

export type Category = {
  id: number;
  attributes: {
    name: string;
    createdAt: string;
    updatedAt: string;
    publishedAt: string;

    icon?: {
      data: {
        id: number;
        attributes: {
          url: string;
        };
      };
    };

    is_active: boolean;
  };
};

export function getCategoriesList() {
  return api.get<{
    data: Category[];
  }>('/categories', {
    params: {
      filters: {
        is_active: true
      },
      pagination: {
        limit: 99999
      },
      populate: ['createdAt', 'icon', 'is_active', 'name', 'updatedAt', 'publishedAt']
    }
  });
}

export function getCategory(id: string) {
  return api.get<{
    data: Category;
  }>(`/categories/${id}`);
}

export function getCategoriesByMachineId(machineId: string) {
  return api.get<{
    data: Category[];
  }>(`/categories/machine/${machineId}`);
}
